import { Address } from "../../../../../features/address"
import { Data2 } from "../../../../../features/data-types"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { DeliveryData } from "../../../../deliveries"
import { useCustomerService } from "../../../services/customerService"
import { useSaleService } from "../../../services/saleService"
import { Customer, SaleOrder } from "../../../state/types"

export const useActions = () => {
    const { getRoutePath } = useRoutesHooks()

    const { createSale, updateSale } = useSaleService()
    const { updateCustomerProps } = useCustomerService()

    const submitCustomerDeliveryAddress = (
        customer: Customer,
        address: Address
    ) => {
        const deliveryAddresses = customer.deliveryAddresses.concat(address)
        return updateCustomerProps(customer.id, { deliveryAddresses })
    }

    const submitSale = async (
        data: Data2,
        branchId: string,
        itemsData: Data2[],
        partialDeliveryData?: Partial<DeliveryData>,
        latePayment?: boolean,
        notes?: string,
        createMode?: boolean,
        keepItemsCustomerTypeYield?: boolean
    ) => {
        const { id, sellerId, customerId, customerTypeId, paymentTypeId, internalNotes } = data
        
        const deliveryData = partialDeliveryData?.method ? {
            ...partialDeliveryData,
            method: partialDeliveryData.method
        } : undefined
        const saleData = {
            id,
            paymentTypeId,
            sellerId,
            customerId,
            customerTypeId,
            branchId,
            deliveryData,
            latePayment,
            notes,
            internalNotes
        }
        
        let savedSale: SaleOrder
        if (createMode) {
            savedSale = await createSale(saleData, itemsData, keepItemsCustomerTypeYield)
        } else {
            savedSale = await updateSale(saleData, itemsData)
        }
        
        Emitter.emit(Event.DB_SUBMIT_DONE, createMode, false, getRoutePath(RoutePath.SALES, savedSale.id))
    }

    return {
        submitCustomerDeliveryAddress,
        submitSale
    }
}
